let now = null;

export function setNow(atString, dateString) {
  const OldDate = (globalThis.__OriginalDate =
    globalThis.__OriginalDate ?? globalThis.Date);

  const at = OldDate.parse(atString);
  const newNow = OldDate.parse(dateString);
  const timeDiff = newNow - at;

  function Date(...args) {
    if (args.length === 0) {
      return new OldDate(Date.now());
    }

    return new OldDate(...args);
  }

  const propertyDescriptors = Object.getOwnPropertyDescriptors(OldDate);
  Object.defineProperties(Date, propertyDescriptors);

  Date.now = function () {
    return OldDate.now() + timeDiff;
  };

  globalThis.Date = Date;

  now = { atString, dateString };
}

export function resetNow() {
  const Date = globalThis.__OriginalDate;
  if (Date == null) {
    return;
  }

  delete globalThis.__OriginalDate;
  globalThis.Date = Date;

  now = null;
}

export function getNow() {
  return now;
}
